import { makeEnum } from '../utils';
export const WidgetListColumnSize = makeEnum('50%', '65%');
